<template>
	<div class="service flex-container align-center-middle width-100" :style="{ backgroundImage: `url(${post.thumbnail})` }">
		<div class="service__content width-100 padding-vertical-3">
			<div class="grid-x align-center width-100">
				<div class="cell medium-10">
					<div class="flex-container align-right width-100 margin-bottom-2">
						<router-link class="service__button button" to="/">Regresar</router-link>
					</div>
					<h2 class="service__title">{{ postTitle }}</h2>

					<div class="grid-x grid-margin-x grid-margin-y">
						<div class="cell medium-4" v-for="(image, index) in gallery">
							<div class="service__image figure">
								<img v-lazy="image.src" @click="openGallery(index)" >
							</div>
						</div>
					</div>

					<LightBox :images="gallery" ref="lightbox" :show-light-box="false"></LightBox>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { HTTP } from '../http-common'
	import LightBox from 'vue-image-lightbox'

	export default {
		components: {
			LightBox
		},

		data() {
			return {
				post: {},
				postTitle: '',
				postContent: '',
				gallery: []
			}
		},

		beforeRouteEnter(to, from, next) {
			HTTP.get(`pages/?slug=${to.params.slug}/`)
				.then( res => {
					next(vm => vm.setData(res.data[0]))
				})
		},

		methods: {
			setData(res) {
				this.post = res;
				this.postTitle = res.title.rendered;
				this.postContent = res.content.rendered;

				res.acf.gallery.map((item) => {
					this.gallery.push({
						thumb: item.url,
						src: item.sizes.medium_large,
						caption: '',
						srcset: ''
					})
				});
			},
			openGallery(index) {
				this.$refs.lightbox.showImage(index)
			}
		}
	}
</script>

<style lang="scss">
	.service {
		$red: #E50019;
		
		background-size: cover;
		background-position: center;
		position: relative;
		width: 100%;
		height: 100%;

		&:before {
			content: "";
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 0;
			background: #1b1b1bd9;
		}

		&__content {
			position: relative;
			z-index: 2;
			height: 100vh;
			overflow-y: scroll;
			padding-bottom: 60px;
		}

		&__title {
			color: #fff;
		}
		&__button {
			background: $red;

			&:hover,
			&:focus {
				background: $red - 20%;
			}
		}

		&__image {
			width: 100%;
			height: 150px;
			overflow: hidden;
			cursor: pointer;

			img	{
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center;
			}
		}
	}
</style>
